import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-pass-key-rename',
  templateUrl: './pass-key-rename.component.html',
  styleUrl: './pass-key-rename.component.scss',
  standalone: false
})
export class PassKeyRenameComponent implements OnInit {

  renamePasskeyUsernameForm: UntypedFormGroup;
  onPasskeyRenameSubmit: (payload: object) => void;
  onPasskeyRenameCancelSubmit: (payload: object) => void;

  constructor() { }

  ngOnInit(): void {
      this.renamePasskeyUsernameForm = new UntypedFormGroup(
      {
        renamePasskeyUsername: new UntypedFormControl('', [
          Validators.required
        ])
      },
      { updateOn: 'submit' }
    );
  }


  onSubmit(){ 
    const newValue =  this.renamePasskeyUsernameForm.value.renamePasskeyUsername;
    this.onPasskeyRenameSubmit({PasskeyName: newValue});   
  }

  keyDownEnter(event: any) {
    event.preventDefault();
  }

  onPasskeyRenameCancel(){
    this.onPasskeyRenameCancelSubmit({flow:'user_cancel'});
  }
}
